import { useEffect, useRef } from 'react';

export const Form = ({ guid, hibisId, scAnswer }) => {
  const ref = useRef(null);

  useEffect(() => {
    const loadForm = async () => {
      const url = `https://emvents.com/form/${guid}/html/`;

      try {
        const response = await fetch(url);
        const html = await response.text();

        if (ref.current) {
          ref.current.innerHTML = html;

          const form = ref.current.querySelector('form[data-emvents-event]');
          if (!form) {
            console.warn('Form not found in loaded HTML.');
            return;
          }

          const pageUrlInput = form.querySelector('input[name="URL"]');
          if (pageUrlInput) {
            pageUrlInput.value = window.location.href;
          }

          const hibisInput = form.querySelector('input[name="hibisid"]');
          if (scAnswer) {
            let radioId = null;
          
            switch (scAnswer.toLowerCase()) {
              case 'a':
                radioId = 'id_form_p1_interes_1';
                break;
              case 'b':
                radioId = 'id_form_p1_interes_2';
                break;
              case 'c':
                radioId = 'id_form_p1_interes_3';
                break;
              case 'd':
                radioId = 'id_form_p1_interes_4';
                break;
              default:
                break;
            }
          
            if (radioId) {
              const radioInput = form.querySelector(`#${radioId}`);
              if (radioInput) {
                radioInput.checked = true;
              }
            }
          }
          if (hibisInput && hibisId) {
            hibisInput.value = hibisId;
          }

          form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const submitter = e.submitter;
            if (submitter) submitter.disabled = true;

            form.querySelectorAll('[data-emvents-msg-type]').forEach(el => el.style.display = 'none');
            form.querySelectorAll('.formbuilder-field-error').forEach(el => el.remove());

            const formId = form.getAttribute('data-emvents-form');
            const eventId = form.getAttribute('data-emvents-event');
            const formData = {};
            const fd = new FormData(form);

            for (let [key, value] of fd.entries()) {
              if (formData[key]) {
                // Convert to array if multiple values exist
                if (!Array.isArray(formData[key])) {
                  formData[key] = [formData[key]];
                }
                formData[key].push(value);
              } else {
                formData[key] = value;
              }
            }

            const headers = {
              'Content-Type': 'application/json',
              'Emvents-Form': formId
            };

            try {
              const postUrl = `https://emvents.com/event/${eventId}/trigger/`;
              const res = await fetch(postUrl, {
                method: 'POST',
                headers,
                body: JSON.stringify(formData)
              });

              if (res.ok) {
                const redirect = form.getAttribute('data-emvents-redirect');
                if (redirect) {
                  window.location.href = redirect;
                } else {
                  if (submitter) submitter.style.display = 'none';
                  const success = form.querySelector('[data-emvents-msg-type="success"]');
                  if (success) success.style.display = 'block';
                }
              } else if (res.status === 400) {
                const errors = await res.json();

                const validation = form.querySelector('[data-emvents-msg-type="validation"]');
                if (validation) validation.style.display = 'block';

                Object.entries(errors).forEach(([field, msgs]) => {
                  const input = form.querySelector(`[name="${field}"]`);
                  if (input) {
                    const error = document.createElement('div');
                    error.className = 'formbuilder-field-error';
                    error.innerHTML = msgs.join(' ');
                    input.after(error);
                  }
                });
              } else {
                const error = form.querySelector('[data-emvents-msg-type="error"]');
                if (error) error.style.display = 'block';
              }
            } catch (err) {
              const error = form.querySelector('[data-emvents-msg-type="error"]');
              if (error) error.style.display = 'block';
            } finally {
              if (submitter) submitter.disabled = false;
            }
          });
        }
      } catch (err) {
        console.error('Error loading emvents form:', err);
      }      
    };

    loadForm();
  }, [guid, hibisId, scAnswer]);

  return (
    <div className="addiko-form">
      <div ref={ref} />
    </div>
  );
};
